const api = require('./abstract');
const auth = require('./auth');
const cards = require('./cards');
const codes = require('./codes');
const comics = require('./comics');
const configuration = require('./configuration');
const landingpages = require('./landingpages');
const loots = require('./loots');
const purchases = require('./purchases');
const rewardchannels = require('./rewardchannels');
const statistics = require('./statistics');
const users = require('./users');
const version = require('./version');
const ranking = require('./ranking');
const settings = require('./settings');
const offers = require('./offers');
const surveys = require('./surveys');
const subscriptions = require('./subscriptions');
const trading = require('./tradingPromotions');
const newsFeed = require('./newsFeed');
const tags = require('./tags');
const slots = require('./slots');
const filters = require('./filters');

module.exports = {
  auth,
  cards,
  codes,
  comics,
  configuration,
  landingpages,
  loots,
  purchases,
  rewardchannels,
  statistics,
  users,
  version,
  ranking,
  settings,
  offers,
  surveys,
  subscriptions,
  setOnCaptchaRequired: api.setOnCaptchaRequired,
  setLegitimateToken: api.setLegitimateToken,
  setOnSuccessfulRequest: api.setOnSuccessfulRequest,
  setSignature: api.setSignature,
  trading,
  newsFeed,
  tags,
  slots,
  filters,
};
